import type { ProgramEventContentObjectDetail } from 'models';
import { useMemo } from 'react';
import { images } from 'common/utils';

type FirstParentInformation = {
  alt: string;
  name: string;
  profilePhoto: string;
};

type P = {
  eventContentObject: ProgramEventContentObjectDetail;
};

export const useGetFirstParentInformation = ({ eventContentObject }: P): FirstParentInformation =>
  useMemo(() => {
    const { name: programName, profilePhoto: programProfilePhoto } = eventContentObject.program;

    return {
      alt: 'Program profile photo',
      name: programName,
      profilePhoto: programProfilePhoto?.url ?? images.default.programProfilePhoto,
    };
  }, [eventContentObject]);
